import { Popover } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import {
  ApplicationStatus,
  LoanStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  updateLoanCommitteeApproval,
  updateLoanRequestStateId,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";
import "./ApprovalModal.css";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { Modules } from "../../../Helpers/Enums/Modules";
import { getContext } from "../../../Helpers/Context/Context";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { debug } from "console";


const useGapStyles = makeStyles({
  paper: {
    marginTop: "-1rem",
  },
});

const ApprovalModal = ({ open, anchorEl, handleClose, loanParam, module }) => {
  const [hideShowComment, setHideShowComment] = useState(true);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [error, setError] = React.useState<any>({});
  const navigate = useNavigate();
  const context = getContext();
  let UserName = [context?.FirstName, context?.MiddleName]
  .filter(Boolean)
  .join(' ');

  const [reviewerRemark, setReviewerRemark] = useState("");
  const [reviewerRemarkOption, setReviewerRemarkOption] = useState([
    { label: "Remark", value: 1 },
    { label: "Remark 1", value: 2 },
    { label: "Remark 2", value: 3 },
  ]);

  const classes = useGapStyles();

  const onChange = (event, value) => {
    if (event === "comment") {
      setComment(value.target.value);
    } else if (event === "approve") {
      setApprove(value);
      setReject(!value);

      setHideShowComment(true);
      setComment("");
    } else if (event === "reject") {
      setReject(value);
      setApprove(!value);

      setHideShowComment(false);
    } else if (event === "reviewerRemark") {
      setReviewerRemark(value);
      setHideShowComment(false);
    }
  };

  const onSubmit = async () => {
    let errorObj = {};

   
    if (approve == false && reject == false) {
      notify(ToastType.Error, "Select at least one checkbox.");

      errorObj = { approve: "Select at least one checkbox." };
    }

    if (approve == false) {
      if (comment == "") {
        errorObj = {
          ...errorObj,
          [comment]: "This field is required",
        };
      } else if (comment.length > 100) {
        errorObj = {
          ...errorObj,
          comment: "Comment should be less than 100 characters",
        };
      }
    }

    setError(errorObj);

    if (Object.keys(errorObj).length === 0) {
      debugger
      let statusId = 0;
      showLoader();
      let requestParams = loanParam;
      requestParams.Comment = comment;
      let Url = "";
      if (module === Modules.LoanModuleApproval) {
          
          Url = updateLoanRequestStateId;
          if(context.loggedInAs?.value === RoleEnum.InternalTeam){
                    const isInternalTeam =
                    context.loggedInAs?.value === RoleEnum.InternalTeam;
                  if (approve === true) {
                    statusId = isInternalTeam
                      ? LoanStatus.LoanModule_PendingMemberLoanConfirmation
                      : LoanStatus.LoanModule_LoanCommitteeApprovalPending;
                  }

                  if (reject === true) {
                    statusId = isInternalTeam
                      ? LoanStatus.LoanModule_RejectedByInternalTeam
                      : LoanStatus.LoanModule_MemberAgreementRejected; // extra status
                  }
          }else if(context.loggedInAs?.value === RoleEnum.HRHOD){
              const isHrHOD =
              context.loggedInAs?.value === RoleEnum.HRHOD;
            if (approve === true) {
              statusId = LoanStatus.LoanModule_PendingWithInternalTeam;
            }

            if (reject === true) {
              statusId = LoanStatus.LoanModule_RejectedByHrHOD; // extra status
            }
          }
       
      } else if (context.loggedInAs?.value === RoleEnum.LoanCommittee) {
        if (module === Modules.LoanCommitteeApproval1) {
          if (approve === true) {
            statusId = LoanStatus.LoanModule_LoanFinalApprovalPending;
          }
          if (reject === true) {
            statusId = LoanStatus.LoanModule_LoanApplicationRejected;
          }
          requestParams["FinalApprover1UserId"] = context?.Id;
          requestParams["ApprovalUser"] = 1;
        } else if (module === Modules.LoanCommitteeApproval2) {
          if (approve === true) {
            statusId = LoanStatus.LoanModule_DocumentGenerationPending;
          }
          if (reject === true) {
            statusId = LoanStatus.LoanModule_LoanApplicationRejected;
          }
          requestParams["FinalApprover2UserId"] = context?.Id;
          requestParams["ApprovalUser"] = 0;
        }
        Url = updateLoanCommitteeApproval;
      }
      requestParams["UserIdApproval"] = context?.Id;
      requestParams.StatusId = statusId;

      const res = await APICall(Url, requestParams);

      if (res.Status == ApiStatus.OK) {
        let mesaage = "";

        if (approve === true) {
          mesaage = "Approve";
        }

        if (reject === true) {
          mesaage = "Reject";
        }

        notify(ToastType.Success, `Request ${mesaage} Successfully`);
        handleClose();

        if (
          [
            Modules.LoanModuleApproval,
            Modules.LoanCommitteeApproval1,
            Modules.LoanCommitteeApproval2,
          ].includes(module)
        )
          navigate("/LoanApprovalDashboard");
      } else {
        notify(ToastType.Error, res?.Message);
      }
      hideLoader();
    }
  };

  return (
    <Popover
      id={"id"}
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        paper: classes.paper,
      }}
      className=""
    >
      <div className="p-3 verify-modal">
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="approve"
                title="Approve"
                onChange={onChange}
                checked={approve}
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="reject"
                title="Reject"
                onChange={onChange}
                checked={reject}
              />
            </div>
          </div>
          <br />
          {!hideShowComment && (
            <div className="row pb-3">
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group">
                  <label>Reviewer Name</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    value={UserName}
                  />
                </div>
                <div className="form-group">
                  <label>Reviewer Remark</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={comment}
                    onChange={(val: any) => onChange("comment", val)}
                  />
                  {/* <SelectForm
                    value={reviewerRemark}
                    placeholder=""
                    options={reviewerRemarkOption}
                    
                  /> */}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent
            icon={""}
            className="btn btn-cancel"
            style={{ marginLeft: 5 }}
            onClick={handleClose}
            value={"Cancel"}
            id={"cancelBtn"}
          />
          <ButtonComponent
            icon={""}
            value={"Submit"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={() => onSubmit()}
          />
        </div>
      </div>
    </Popover>
  );
};

export default ApprovalModal;
